import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNewApiInstance } from "../../services/api.js";

// Get notifications list +
export const getNotificationsList = createAsyncThunk(
  "notifications/getNotificationsList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/notifications/me`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get notification by ID +
export const getNotificationById = createAsyncThunk(
  "notifications/getNotificationById",
  async (notificationId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/notifications/${notificationId}`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get unread notifications count +
export const getUnreadNotificationsCount = createAsyncThunk(
  "notifications/getUnreadNotificationsCount",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/notifications/unread-count`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Mark notification as read +
export const markNotificationAsRead = createAsyncThunk(
  "notifications/markNotificationAsRead",
  async (notificationId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/notifications/${notificationId}/read`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Mark all notifications as read +
export const markAllNotificationsAsRead = createAsyncThunk(
  "notifications/markAllNotificationsAsRead",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/notifications/read-all`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
